import bundlesListSaga from './bundlesList'
import keysListSaga from './keysList'
import languageTypesSaga from './languageTypes'
import localsSaga from './locals'
import updateLanguageSaga from './updateLanguage'

const localizationSaga = [bundlesListSaga(), keysListSaga(), languageTypesSaga(), localsSaga(), updateLanguageSaga()]

export default localizationSaga
